// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/vercel/path0/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/vercel/path0/.cache/json/layout-index.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/vercel/path0/.cache/json/index.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/vercel/path0/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js